import PropTypes from 'prop-types';
import { ESTADOS_META } from '../../features/tickets';

const EstadoBadge = ({ estadoId = null }) => {
  const meta = ESTADOS_META[estadoId] || { label: '—', tone: 'gris' };
  return <span className={`tickets-badge tickets-badge--${meta.tone}`}>{meta.label}</span>;
};

EstadoBadge.propTypes = {
  estadoId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default EstadoBadge;
